import { resource } from 'appConstants';
import config from './config';
import { axios } from 'util/Api';
import { extLocalStore } from 'util/localStorage';

const stringifyMessage = (message) => {
	if (typeof message === 'string') return message;
	const { err, ...otherMessageProps } = message;
	let stringifiedErr = '';
	if (err) {
		try {
			stringifiedErr = JSON.stringify(err, Object.getOwnPropertyNames(err));
		} catch (e) {
			const errMessage = 'Error stringifying error object for Logger ';
			stringifiedErr = errMessage;
			// eslint-disable-next-line no-console
			console.error(errMessage, e);
		}
	}

	let stringifiedMessage = '';
	try {
		stringifiedMessage = JSON.stringify({ ...otherMessageProps, err: stringifiedErr });
	} catch (e) {
		const errMessage = 'Error stringifying message for Logger ';
		stringifiedMessage = JSON.stringify({
			message: errMessage,
			err: stringifiedErr
		});
		// eslint-disable-next-line no-console
		console.error(errMessage, e);
	}
	return stringifiedMessage;
};

const createRequestObj = (props, username) => {
	const { message } = props;
	const { pathname, hash } = window.location;
	const sumoPage = pathname + hash;
	const {
		sumo: { sourceCategory }
	} = config;
	return {
		...props,
		message: stringifyMessage(message),
		sourceCategory,
		// API expects sumo_page
		// eslint-disable-next-line camelcase
		sumo_page: sumoPage,
		username: username || 'unknown'
	};
};

/**
 * @typedef {'trace' | 'debug' | 'info' | 'warn' | 'error' | 'fatal'} LogLevel
 */

/**
 * @typedef {Object} LoggerProps
 * @property {LogLevel} level
 * @property {string | Record<string, unknown>} message
 */
/**
 * @param {LoggerProps} props
 */
export async function sendToLogger(props) {
	const { accountId, username } = extLocalStore;
	const reqObj = createRequestObj(props, username);
	try {
		if (accountId) {
			// API expects account_id
			// eslint-disable-next-line camelcase
			return await axios.post(resource.TRACK_ACTIVE, { ...reqObj, account_id: accountId });
		}
		return await axios.post(resource.TRACK_SESSION, reqObj);
	} catch (err) {
		// eslint-disable-next-line no-console
		console.error(
			`Error logging to Logger ${accountId ? 'Authenticated' : 'Unauthenticated'}: `,
			err
		);
		return null;
	}
}
